import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import module from 'app/store/seatPlan';

const { legendRequest, clearLegend } = module.actions;

export default function(cinemaId, sessionId) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(legendRequest(cinemaId, sessionId));

    return () => dispatch(clearLegend());
  }, [cinemaId, sessionId, dispatch]);
}
